const { dateBucket } = require('./dateGroups');

function parsePushMessageId(query) {
  const n = Number(query && query.id);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n;
}

function staffInboxPushUrl(kind, id) {
  const path = kind === 'voice' ? '/mvoice' : '/msms';
  const n = Number(id);
  if (Number.isFinite(n) && n > 0) return `${path}?id=${n}`;
  return path;
}

function pushHighlightPlan({ query, inbox, now } = {}) {
  const id = parsePushMessageId(query);
  if (!id) return null;
  const row = (Array.isArray(inbox) ? inbox : []).find(
    (msg) => Number(msg && msg.id) === id,
  );
  if (!row) {
    return { id, found: false, expandGroup: null };
  }
  const when = row.createdOn || row.createdAt;
  return {
    id,
    found: true,
    expandGroup: dateBucket(when, now || new Date()),
  };
}

module.exports = {
  parsePushMessageId,
  staffInboxPushUrl,
  pushHighlightPlan,
};
